import { getAppApiRoutes } from "../../Global";
import { TerminalErrorDescriptionFilterRequestModel } from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class TerminalErrorDescriptionService {
  async getTerminalErrorDescriptions(filter: TerminalErrorDescriptionFilterRequestModel = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminalErrorDescription.getTerminalErrorDescriptions, {
      filter,
      orderBy: "errorCode_asc",
    });
  }
}

const service: TerminalErrorDescriptionService = new TerminalErrorDescriptionService();
export default service;
